export default __webpack_public_path__ + "static/media/index500.94ead02b.png";